import { createApiRef } from '@backstage/core-plugin-api';

/** @public */
export const azDevopsApiRef = createApiRef<AzDevopsApi>({
  id: 'plugin.azdevops.client',
});

export interface AzDevopsApi {
  getProjects(): Promise<ProjectList>;
  workItemsByQuery(project: string, team: string, top: number): Promise<any>;
  getTeamsByProject(projectId: string): Promise<ProjectTeams>;
  updateWorkItem(id: number, state: string): Promise<any>;
  getWorkItemTypes(project: string): Promise<any>;
  getWorkItemStateByType(
    project: string,
    workItemtype?: string | undefined,
  ): Promise<any>;
  getTeamMembersDayOff(project: string): Promise<TeamMember[]>;
  getTeamMembers(projectId: string): Promise<TeamMemberMeta[]>;
}

export type TeamMemberMeta = {
  identity: TeamMember;
  isTeamAdmin?: boolean;
};

export type TeamMember = {
  descriptor: string;
  displayName: string;
  id: string;
  imageUrl: string;
  uniqueName: string;
  url: string;
};

export type WorkItemFields = {
  id?: number;
  fields?: Fields;
};

export type Fields = {
  WorkItemType?: string;
  Title?: string;
  State?: string;
  CreatedDate?: string;
  Parent?: string;
};

export type WorkItems = {
  id: number;
  fields: {
    'System.WorkItemType': string;
    'System.Title': string;
    'System.State': string;
    'System.CreatedDate': string;
    'System.Parent': string;
    ParentTitle: string;
    WorkItemStates?: WorkItemState[]; // New field to include WorkItemStates
  };
};

export type request = {
  url: string;
  method: string;
  scope: string[];
  body?: any;
};

export type ProjectList = {
  id: string;
  name: string;
};

export type ProjectTeams = {
  id: string;
  name: string;
  defaultTeam?: DefaultTeam;
};

export type DefaultTeam = {
  id: string;
  name: string;
};

export type WorkItemState = {
  name?: string;
  color?: string;
  category?: string;
};
